// Refinisher Min/Max ("splitBetween") for calendar events — single source of
// truth for WHERE the number lives and how it is shown (2026-10-29, plan
// bdr_mobile_app/plans/placeholder_split_between_2026_10_29.md). Mirrors the
// getCalendarJobCategory pattern: WeekModal, DayViewModal and the event
// modals import from here instead of carrying their own copies.
//
// Where the number lives:
//   - a job with an invoice / quote keeps it on that doc (`splitBetween`);
//   - a TENTATIVE PLACEHOLDER has no doc, so it rides on the calendar item as
//     `placeholderSplitBetween` — read ONLY while `isPlaceholder` is true.
//     On promote the server fills the doc (when the doc has none) and drops
//     the item field, so a doc-bearing event never reads the item.
//
// "First NON-EMPTY array", not `||`: a Mongoose array defaults to [], which
// is truthy, so `invoice.splitBetween || quote.splitBetween` let an invoice
// with no number hide a quote's "2-3". Same rule for the placeholder fallback.

export const firstNonEmptyArray = (...arrs) =>
  arrs.find((a) => Array.isArray(a) && a.length > 0) || null;

/** The [min] / [min, max] array an event should show, or null. */
export const getSplitBetween = (item) => {
  if (!item) return null;
  const docSplit = firstNonEmptyArray(
    item.invoice?.splitBetween,
    item.quote?.splitBetween
  );
  if (docSplit) return docSplit;
  const ci = item.calendarItem;
  if (ci?.isPlaceholder) return firstNonEmptyArray(ci.placeholderSplitBetween);
  return null;
};

/** "2-3" for [2, 3], "2" for [2] or [2, 2], null for empty / missing. */
export const formatFinisherRange = (arr) => {
  if (!Array.isArray(arr) || arr.length === 0) return null;
  const min = arr[0];
  const max = arr[arr.length - 1];
  return min === max ? `${min}` : `${min}-${max}`;
};

/** The chip text for an event block (bottom-left of WeekModal / DayView blocks). */
export const getFinisherRange = (item) => formatFinisherRange(getSplitBetween(item));

/**
 * The array the modals send from their Min / Max steppers: [] when both are
 * blank, [min] when only one is set or both are equal, else [min, max].
 * Same shape the doc path has always sent; the server normalizes order.
 */
export const buildSplitBetween = (minStr, maxStr) => {
  const minVal = parseInt(minStr);
  const maxVal = parseInt(maxStr);
  const out = [];
  if (!isNaN(minVal)) out.push(minVal);
  if (!isNaN(maxVal) && maxVal !== minVal) out.push(maxVal);
  return out;
};
